<template>
	<v-card
		id='filter-list'
		ref='filter-list'
		class='shadow no-text-highlight pa-0 mb-6'
	>
		<v-card-title
			id='header'
			style='position: relative; height: 69px'
			class='pa-2 ma-0 d-inline-flex align-center justify-center font-weight-bold'
		>
			<v-icon class='mr-2' color='primary'>
				fas fa-sliders-h
			</v-icon>
			Ergebnisse filtern
		</v-card-title>

		<v-card-text class='pa-0 ma-0'>
			<loading-spinner v-if='loading' text='Filter werden geladen...' />

			<v-list
				v-else
				class='pa-0 ma-0'
				style='padding-top: 3px'
				elevation='0'
				two-line
			>
				<template v-for='(f, index) in $store.filters'>

					<v-divider
						:key='index'
					/>
					<v-menu
						:ref='"menu-"+f.name'
						:key='f.name'
						v-model='filterList[f.name]'
						:close-on-click='false'
						content-class='filter-dialog'
						bottom
						right
						:offset-x='true'
						nudge-right='30'
						:nudge-top='nudgeTop'
						transition='scale-transition'
						:close-on-content-click='false'
						:min-width='846'
						:max-width='846'
						:allow-overflow='true'
						z-index='1500'
					>
						<template v-slot:activator='{ on, attrs }'>
							<v-list-item
								:id='"list-item-" + index'
								:key='f.label'
								v-bind='attrs'
								class='list-item filter-class'
								:class='{
									"last": isFilterLast(index),
									"overlay-active": filterList[f.name]
								}'
								:disabled='$store.actions.getDisabledStatus(f)'
								:ripple='!$store.actions.getDisabledStatus(f)'
								@click='$store.actions.getDisabledStatus(f) ? "" : triggerOverlay(f,"list-item-" + index, attrs)'
							>
								<v-list-item-content class='primary--text' :disabled='$store.actions.getDisabledStatus(f)'>

									<v-row
										align='center'
										justify='space-between'
										no-gutters
										style='width: 100%'
									>
										<v-col cols='12'>

											<div class='d-flex justify-space-between align-center'>
												<span class='font-weight-bold pr-2' v-html='f.label' />

												<v-icon color='primary' size='12'>
													fal fa-pencil-alt
												</v-icon>
											</div>
										</v-col>

										<v-col class='mt-1 pr-4' cols='12'>
											<div class='text-ellipsis' style='font-size: 12px; color: #989ca5;'>
												{{ getDisplayLabel(f) }}
											</div>
										</v-col>
									</v-row>

									<v-row
										v-if='f.infotext'
										align='center'
										class='mt-3'
										justify='space-between'
										no-gutters
									>
										<v-col class='mr-2 flex-grow-0'>
											<v-icon
												color='primary'
												size='13.5'
												style='margin-bottom: 2.5px'
											>
												fal fa-info-circle
											</v-icon>
										</v-col>

										<v-col style='font-size: 11px'>
											{{ f.infotext }}
										</v-col>
									</v-row>
								</v-list-item-content>

							</v-list-item>
						</template>

						<v-list class='pa-0 ma-0' style='border-radius: 3px'>
							<v-list-item class='pl-0 pr-0'>
								<FilterContent :current-filter.sync='currentFilter' :close='closeModal' />
							</v-list-item>
						</v-list>
					</v-menu>



				</template>
				<v-overlay :value='overlay' z-index='1499' />

			</v-list>
		</v-card-text>

	</v-card>
</template>

<script>
import FilterContent from './FilterContent'
import LoadingSpinner from './LoadingSpinner'
import utils from '../libs/utils'
import cloneDeep from 'lodash.clonedeep'


export default {
	name: 'FilterList',
	components: {LoadingSpinner, FilterContent},
	data() {
		return {
		  filterList: {},
		  items: [],
		  overlay: false,
			currentFilter: undefined,
			loading: true,
			showDialog: false,
			cardMaxHeight: '70%',
			cardMinHeight: '450px',
			scrollbarOptions: {
				scrollbars: {
					clickScrolling: true,
				},
				overflowBehavior: {
					x: 'hidden',
					y: 'scroll'
				}
			}
		}
	},
  computed: {
	  nudgeTop: function() {
      let headerHeight = 0;
      if(document.getElementsByClassName('navbar').length > 0) {
        headerHeight += document.getElementsByClassName('navbar')[0].clientHeight
      }
      if(document.getElementsByClassName('header-bar').length > 0) {
        headerHeight += document.getElementsByClassName('header-bar')[0].clientHeight;
      }
      //120 is the current headerHeight without integration into blade, we need to add the headerbar
      return headerHeight;
    }
  },
  watch: {
    filterList: {
      handler(changed) {
        if(changed[this.currentFilter.name] === undefined) {
          return;
        }
        this.$nextTick(() => {
          console.log()
          this.overlay = changed[this.currentFilter.name]
        })
      },
      deep: true
    }
  },
	async mounted() {
		this.loading = false

		// rerender when filter changes outside (eg. chips)
		this.$bus.$on('filters-updated', () => {
			this.$forceUpdate()
		})
  },
	methods: {
	  async triggerOverlay(filter, elementId, activatorAttrs) {
	    if(activatorAttrs['aria-expanded'] === 'false') {
        const clone = cloneDeep(filter)
        clone.elementID = elementId
        this.currentFilter = clone
        this.$set(this.filterList,filter.name, true);
        this.$bus.$emit('v-menu-open:'+clone.name, {})
      } else {
	      this.closeModal(filter);
        this.$bus.$emit('v-menu-close:'+this.currentFilter.name, {})

      }
    },
    closeModal(filter) {
	    this.overlay = false;
      this.$set(this.filterList,filter.name, false);
    },
		getDisplayLabel(filter) {
			return utils.getDisplayLabel(filter)
		},
		isFilterLast(index) {
	    return index === this.$store.filters.length -1
    }
	}
}
</script>

<style lang='scss'>
@import 'src/styles/variables';

#catalog-container {
  #filter-list {
    padding-bottom: 6px !important;

    .v-list-item__content > * {
      line-height: 1.3 !important;
    }

    .v-list-item__content {
      padding: 12px 0 !important;
      min-height: 60px !important;
      font-size: 13.5px !important;
    }

    .v-list-item.list-item {
      padding: 0 18px;
      min-height: 69px;
    }

    #header {
      border-top-left-radius: $border-radius-root;
      border-top-right-radius: $border-radius-root;
      padding: 0 12px;
      font-size: 19px;
      width: 100%;

      .v-toolbar__content {
        width: 100%;
        font-weight: 600;
        justify-content: center;
      }

      &.v-app-bar--is-scrolled {
        box-shadow: none !important;
        border-bottom: 1.6px solid black !important;
      }

    }

    .overlay-active {
      z-index: 1500;
      background-color: white;
    }
  }

  .filter-dialog {
    contain: inherit;
    overflow: inherit;
    display: block;

    &::before {
      content: "";
      width: 0px;
      height: 0px;
      position: absolute;
      border-left: 20px solid transparent;
      border-right: 20px solid #FFFFFF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      left: -39px;
      top: 145px;
    }
  }
}
</style>
